const initialState = {
    surveyData: [],
    currentProgress: 0,
    progessStepsDetails: {},
    feedbackQuestionsData: [],
    demographicQuestionData: [],
    isEligible: true,
    entrepreneurialDemographicsQuestions: {

    }
}
export default function surveyQuestionsReducers(state = initialState, action) {
    switch (action.type) {
        case 'FETCH_SURVEY_QUESTIONS_SUCCESS':
            return {
                ...state,
                surveyData: action.payload,
                progessStepsDetails: getProgessStepDetails(action.payload)
            }
        case 'GET_PROGRESS_PERCENT':
            return {
                ...state,
                currentProgress: getCureentProgress(state?.surveyData?.[0], action.payload)
            }
        case 'FETCH_FEEDBACK_QUESTIONS_SUCCESS':
            return {
                ...state,
                feedbackQuestionsData: action?.payload
            }
        case "FETCH_ENTREPRENEURIAL_SURVEY_QUESTIONS_SUCCESS":
            return {
                ...state,
                entrepreneurialDemographicsQuestions: action?.payload,
                isEligible: true,
                timeStart: new Date().getTime()
            }
        case "FETCH_ENTREPRENEURIAL_SURVEY_QUESTIONS_ERROR":
            if (action.payload?.message === "canceled") return { ...state }
            return {
                ...state,
                entrepreneurialDemographicsQuestions: {},
                message: action?.payload?.response?.data?.message,
                isEligible: action?.payload?.response?.data?.message === "User Disqualify" ? false : true
            }
        case 'FETCH_DEMOGRAPHIC_QUESTIONS_SUCCESS':
            return {
                ...state,
                demographicQuestionData: action.payload
            }
        case 'RESET_SURVEY_QUESTIONS':
            return {
                ...state,
                surveyData: [],
                progessStepsDetails: {}
            }
        case 'RESET_FEEDBACK_QUESTIONS':
            return {
                ...state,
                feedbackQuestionsData: [],
                progessStepsDetails: {}
            }
        case "FETCH_ENTREPRENEURIAL_REPORT_SUCCESS":
        case "FETCH_ADMIN_ENTREPRENEURIAL_REPORT_SUCCESS":
            // let dummyData = {...action?.payload?.export_data, subscale_percentiles :{...action?.payload?.export_data?.subscale_percentiles, Analytical_Reasoning: 70,  Empathetic_Reasoning: 10}}
            return {
                ...state,
                entrepreneurialReport: action?.payload?.export_data || {},
                assessmentDate: action?.payload?.assessment_date || new Date(),
                userAccess: action?.payload?.access || ''
            }
        case "FETCH_ENTREPRENEURIAL_REPORT_ERROR":
        case "FETCH_ADMIN_ENTREPRENEURIAL_REPORT_ERROR":
            return {
                ...state,
                entrepreneurialReport: {},
            }
        case "RESET_ENTREPRENEURIAL_REPORT":
            return initialState
        default:
            return state
    }
}

const getProgessStepDetails = (data) => {
    if (data && data.length && data?.[0]?.steps && data?.[0]?.steps?.length) {
        return data?.[0]?.steps?.[0]
    }
}

const calculateStepPercentages = (questionsPerStep, totalSteps) => questionsPerStep.map(questions => (100 / totalSteps) / questions);

const calculateProgress = (currentStepIndex, answersInCurrentStep, stepPercentages, totalSteps) => {
    const completedStepsProgress = currentStepIndex * (100 / totalSteps); // Each completed step contributes 25%
    const currentStepProgress = answersInCurrentStep * stepPercentages[currentStepIndex]; // Progress in the current step
    return completedStepsProgress + currentStepProgress;
};

function getCureentProgress(surveyData, answersInCurrentStep = 0) {
    if (surveyData && surveyData?.steps) {
        let stepsData = surveyData?.steps?.[0]
        let questionsPerStep = stepsData?.per_step_ques
        let totalSteps = stepsData?.total_steps
        let currentStep = stepsData?.current_step
        let stepPercentages = calculateStepPercentages(questionsPerStep, totalSteps)
        let progress = calculateProgress(currentStep, answersInCurrentStep, stepPercentages, totalSteps)
        return progress
    } else {
        return 0
    }

}


